<template>
  <div>{{ JSON.stringify({ status: 'ok' }) }}</div>
</template>
